<script setup>
import {computed, onMounted} from "vue";
import {useClubSignUpStore} from "@/store/club-signup";
import MainPreloader from "@/components/shared/MainPreloader.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import {useRouter} from "vue-router";

const store = useClubSignUpStore();
const router = useRouter();
const signup = computed(() => store.signup);

const details = computed(() => {
  if (!signup.value) return {title: 'Заявка не подана', text: 'Вы можете подать заявку на вступление в клуб.'};
  if (signup.value.status === 'approved') return {title: 'Вы приняты в клуб', text: 'Ваша заявка одобрена. Добро пожаловать в клуб!'};
  if (signup.value.status === 'rejected_final') return {title: 'Заявка отклонена', text: 'Повторная подача заявки недоступна.'};
  if (signup.value.status === 'rejected') return {title: 'Заявка отклонена', text: 'Вы можете подать новую заявку после устранения причин отказа.'};
  return {title: 'Заявка рассматривается', text: 'Срок рассмотрения заявки — до 14 рабочих дней. Результат также будет отправлен на электронную почту.'};
});

const isRejected = computed(() => ['rejected', 'rejected_final'].includes(signup.value?.status));

function formatDate(value) {
  return value ? new Date(value).toLocaleString('ru-RU') : '—';
}

onMounted(() => store.loadClubSignUp());
</script>

<template>
  <div class="clubSignupStatus">
    <MainPreloader v-if="store.loading" position="fixed" :size="80" :stroke="3"/>
    <section class="clubSignupStatus__card">
      <h2 :class="{'clubSignupStatus__title--danger': isRejected}">{{ details.title }}</h2>
      <p>{{ details.text }}</p>
      <template v-if="signup">
        <dl>
          <dt>Дата подачи</dt><dd>{{ formatDate(signup.submitted_at) }}</dd>
          <template v-if="signup.resolved_at"><dt>Дата решения</dt><dd>{{ formatDate(signup.resolved_at) }}</dd></template>
        </dl>
      </template>
      <ActionButton v-if="!signup || signup.status === 'rejected'" @buttonClick="router.push({name: 'ClubSignUpView'})">
        <template #caption>{{ signup ? 'Подать новую заявку' : 'Подать заявку' }}</template>
      </ActionButton>
    </section>
  </div>
</template>

<style scoped lang="scss">
.clubSignupStatus__card {
  padding: 24px;
  border-radius: 20px;
  background: var(--cd-card-bg);
  text-align: left;
}
h2 { margin: 0 0 14px; color: var(--cd-base-green); font-size: 20px; }
h2.clubSignupStatus__title--danger { color: var(--cd-danger); }
p { margin: 0 0 20px; }
dl { display: grid; grid-template-columns: 160px 1fr; gap: 10px; margin: 0 0 24px; }
dt { color: var(--cd-text-muted); }
dd { margin: 0; }
</style>
